import React, { useMemo, useRef, useEffect } from "react";
import { Route, useHistory, withRouter } from "react-router-dom";
import { event, lib } from "../index";
import { Tabs, Tooltip } from "antd";
import md5 from "md5";
function NavigationHeader({ pageList }) {
    let history = useHistory();
    let activeKey = decodeURIComponent(window.location.pathname + window.location.search);
    const items = useMemo(() => {
        return pageList.map(item => {
            return {
                key: item.url,
                label: lib.getParam("page_tip", item.url) ? (
                    <Tooltip title={lib.getParam("page_tip", item.url)}>
                        <span>{lib.getParam("page_title", item.url)}</span>
                    </Tooltip>
                ) : (
                    lib.getParam("page_title", item.url)
                ),
            };
        });
    }, [pageList]);
    return (
        <div className="navigation-header">
            <Tabs
                type="editable-card"
                hideAdd
                activeKey={activeKey}
                onChange={url => history.push(url)}
                onEdit={url => {
                    lib.closePage(url);
                }}
                items={items}
            />
        </div>
    );
}
//useMemo

function MemoPage({ match, Page, name, configList, url }) {
    let memoPage = useMemo(() => <Page name={name} url={url} configList={configList} />, []);
    useEffect(() => {
        const url = window.location.href;
        const refreshEvent = lib.getParam("refresh_event");
        return () => {
            event.off(refreshEvent, () => {}, decodeURIComponent(url));
        };
    }, []);
    return (
        <div style={{ display: match ? "block" : "none" }} className={`main-page ${name}`}>
            {memoPage}
        </div>
    );
}

function NavigationBody({ pageList, pageMap, configList }) {
    return (
        <div className="navigation-body">
            {pageList.map((item, index) => {
                var path = item.url.split("?")[0];
                var names = path.split("/");
                var name = names.pop();
                var Page = pageMap[name];
                let match =
                    decodeURIComponent(window.location.pathname + window.location.search) ==
                    decodeURIComponent(item.url);
                if (!Page) {
                    console.error(`can't find page for name ${name}`);
                    return <div key={index}></div>;
                }
                return (
                    <Route
                        key={item.url}
                        path={path}
                        children={props => (
                            <MemoPage
                                match={match}
                                url={item.url}
                                Page={Page}
                                name={name}
                                configList={configList}
                                childrenProps={props}
                            />
                        )}
                    />
                );
            })}
        </div>
    );
}

function Navigation({ pageList, pageMap, configList }) {
    return (
        <div className="app-navigation">
            <NavigationHeader pageList={pageList} />
            <NavigationBody pageList={pageList} pageMap={pageMap} configList={configList} />
        </div>
    );
}

export default withRouter(Navigation);
